import { NgModule } from '@angular/core';
import { AppCurrencyPipe } from './CurrencyPipe.pipe';
import { CurrencyPipe } from '@angular/common';

@NgModule({
  declarations: [
    AppCurrencyPipe
  ],
  exports: [
    AppCurrencyPipe
  ],
  providers: [
    CurrencyPipe
  ]
})
export class AppCurrencyPipeModule {}